<template>
  <div>
    <collapse :multiple-active="false" :active-index="-1">
      <collapse-form-item
        id="VerifyReceiptQuantityStep"
        title="Verify Receipt Quantities"
        @tabOpen="loadItem"
        :status="lineItemReceiptStatus"
        v-bind:tabChange="getAllState.receipt"
        name="1"
      >
        <div>
          <verify-receipt-quantity
            :is-read-only="isReadOnly"
            ref="VerifyReceiptQuantityStep"
            @validated="onSubStepValidated"
          ></verify-receipt-quantity>
        </div>
      </collapse-form-item>
  
      <collapse-form-item
        id="InspectedReceivedByStep"
        title="Inspected / Received By (Signature)"
        @tabOpen="loadItem"
        :status="inspectedReceivedByStatus"
        v-bind:tabChange="getAllState.receipt"
        name="2"
      >
        <div>
          <inspected-received-by
            :is-read-only="isReadOnly"
            v-on:show-document-tab="showDocumentTab"
            ref="InspectedReceivedByStep"
            @validated="onSubStepValidated"
          ></inspected-received-by>
        </div>
      </collapse-form-item>
     
    </collapse>
  </div>
</template>

<script>
import VerifyReceiptQuantity from "@/components/App/order/receipt/verifyreceiptquantity/VerifyReceiptQuantity.vue";
import InspectedReceivedBy from "@/components/App/order/receipt/InspectedReceivedBy.vue";
import { Select, Option } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";


export default {
  props: ["isReadOnly"],
  name: "Receipt",
  components: {
    VerifyReceiptQuantity,
    InspectedReceivedBy,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
  },

  data() {
    return {
      status: null,
      loadSignature: false,
    };
  },
  mounted() {
    this.getLineItemReceiptStatus(this.$route.params.id);
    this.getInspectedReceivedByStatus(this.$route.params.id);
    this.getDisbursingCollectionOutstandingBalance(this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      lineItemReceiptStatus: "lineItemReceipt/lineItemReceiptStatus",
      inspectedReceivedByStatus: "inspectedReceivedBy/inspectedReceivedByStatus",
      getAllState: "moduleState/getAllStates"
    }),
  },
  methods: {
    ...mapActions({
      getLineItemReceiptStatus: "lineItemReceipt/getLineItemReceiptStatus",
      getInspectedReceivedByStatus: "inspectedReceivedBy/getInspectedReceivedByStatus",
      submitReceiving: "orderMetadata/submitReceiving",
      getDisbursingCollectionOutstandingBalance:
      "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalance",
    }),
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    this.getDisbursingCollectionOutstandingBalance(this.$route.params.id)
    },
    loadItem(ref) {
      switch (ref) {
        case "VerifyReceiptQuantityStep":
          this.getLineItemReceiptStatus(this.$route.params.id);
          break;
        case "InspectedReceivedByStep":
           this.getInspectedReceivedByStatus(this.$route.params.id);
          break;
        default:
          break;
      }

      return this.$refs[ref].loaded();
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'RECEIVING REPORT')
      
    },
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}
</style>
